<template>
  <div>
    <div v-if="loading" style="margin-top:3.5rem;"><LoadingText /></div>
    <div v-else>
      <template v-for="(item,index) in list" >
        <v-row style="margin:0;" :key="index"  >
          <v-col :cols="12" style="padding:0.3rem 0;">
            <div style="padding:0.3rem;">
              <span>任务名称：{{ item.inst_job_name }}</span>
            </div>
            <div style="padding:0.3rem;">
              <span>结果：</span>
              <span :style="item.inst_status_text.indexOf('成功') === -1 ? 'color:#F56C6C':'color:#67C23A'">{{item.inst_status_text}}</span>
              <span style="margin-left:15px;">备份方式：{{item.inst_backup_type_text}}</span>
            </div>
            <div style="padding:0.3rem;">
              <span>开始时间：{{$moment(item.backup_start_time).format("YYYY-MM-DD HH:mm:ss")}}</span>
            </div>
            <div style="padding:0.3rem;">
              <span>结束时间：{{$moment(item.backup_end_time).format("YYYY-MM-DD HH:mm:ss")}}</span>
            </div>
          </v-col>
        </v-row>
      </template>
      <div v-if="list.length === 0" style="text-align:center;margin-top:1rem;color:#9e9e9e;font-size:0.8rem;">
          暂无备份记录
      </div>
    </div>
  </div>
</template>

<script>
import LoadingText from '@/views/components/LoadingText'
export default {
  components: {
    LoadingText
  },
  props: {
    iotId: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      list: [],
      // 是否有更多数据
      hasMore: true,
      pageIndex: 1,
      pageCount: 10,
      // 是否过滤3天内记录
      filter3DayBefore: true,
      // 加载状态
      loading: true,
      // 是否3天内有记录
      has3DayData: false
    }
  },
  computed: {
  },
  mounted() {
    var that = this
    that.$nextTick(() => {
      that.init()
    })
  },
  created() {
  },
  methods: {
    // 初始化
    async init() {
      var that = this
      var res = await that.$api.iot.submitServiceCmd({ iot_id: that.iotId, method: 'backup_job_instances', role: 1 })
      // console.log('getBackupList.res', res)
      if (!res.success) {
        that.loading = false
        return
      }
      var data = res.data
      if (!data.length) {
        that.loading = false
        return
      }
      that.list = data.items
      that.loading = false
    }
  }
}
</script>

<style scoped>
</style>
